import { render, staticRenderFns } from "./seeding.vue?vue&type=template&id=5178baa1&scoped=true"
import script from "./seeding.vue?vue&type=script&lang=ts"
export * from "./seeding.vue?vue&type=script&lang=ts"
import style0 from "./seeding.vue?vue&type=style&index=0&id=5178baa1&prod&lang=less&scoped=true"
import style1 from "./seeding.vue?vue&type=style&index=1&id=5178baa1&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5178baa1",
  null
  
)

export default component.exports